export default __webpack_public_path__ + "static/11-3b0b446731fa1ba797f10ae32e03521b.webp";